import { storyblokEditable, renderRichText } from "@storyblok/react";

const IconItem = ({ blok }) => {
  const isLeftAligned = blok.left_align_text;

  return (
    <div
      className={`flex flex-col ${
        isLeftAligned ? "items-start text-left" : "items-center text-center"
      } max-w-[250px]`}
      {...storyblokEditable(blok)}
    >
      {/* Icon image */}
      {blok.icon?.filename && (
        <img
          src={blok.icon.filename}
          alt={blok.icon.alt || "Icon"}
          className="w-[200px] h-[200px] object-contain mb-4"
        />
      )}

      {/* Title */}
      {blok.title && (
        <h3 className="font-semibold text-base mb-2">
          {blok.title}
        </h3>
      )}

      {/* Body */}
      {blok.body && (
        <p className="text-sm leading-relaxed">
          {typeof blok.body === "string"
            ? blok.body
            : renderRichText(blok.body)}
        </p>
      )}
    </div>
  );
};

export default IconItem;
